import React, { useState, useCallback, Fragment, useContext } from 'react'//,{useState,useCallback}
import styles from './GroupsSettings.module.css'
import { useTranslation } from "react-i18next";
import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
// import serverUrl from '../../../../serverUrl'
import userIcon from '../../../../assets/userIcon.png'
import * as groupsReq from '../../../../axios/requests/groupsReq'
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import * as settings from '../../../../settings'
import DropDownV2 from '../../../UI/DropDownV2/DropDownV2';

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

const english = /^[A-Za-z0-9]*$/;
const CallBackSettings = (props) => {
    const [t] = useTranslation('common')
    let groupSetting = props.groupSetting
    const alertCtx = useContext(AlertContext)
    const selectedGroupStateDefault = { _id: 'Create new group', groupName: t('Create new group default', { groupType: t(groupSetting.type) }), uniqGroupName: 'Create new group' }
    const [selectedGroupState, setSelectedGroupState] = useState(selectedGroupStateDefault)
    const [selectedGroupEditableState, setSelectedGroupEditableState] = useState(selectedGroupStateDefault)
    const [onCreateNewGroupMsgState, setOnCreateNewGroupMsgState] = useState('')

    let setsettings = props.setsettings
    let company_groupList = [selectedGroupStateDefault, ...props.company_groupList]
    let isSelectedDefaulGroup = selectedGroupState.uniqGroupName === selectedGroupStateDefault.uniqGroupName
    let setSaveAndRestartBtnActiveState = props.setSaveAndRestartBtnActiveState
    //useCallbacks
    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        setsettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setsettings, setSaveAndRestartBtnActiveState])
    const onGroupSelect = useCallback((group) => {
        // if (group.uniqGroupName !== selectedGroupStateDefault.uniqGroupName) {
        setSelectedGroupState(group)
        setSelectedGroupEditableState(group)
        setOnCreateNewGroupMsgState('')

    }, [setSelectedGroupState, setSelectedGroupEditableState])

    const onGroupEditableInputChange = useCallback((changeObj) => {//event.target.value
        setSelectedGroupEditableState({ ...selectedGroupEditableState, ...changeObj })
    }, [setSelectedGroupEditableState, selectedGroupEditableState])

    const onGroupSaveClick = useCallback(() => {
        if (isSelectedDefaulGroup) {//save
            //Check save group conditions 
            if (selectedGroupEditableState.groupName.length < 4 || selectedGroupEditableState.groupName === selectedGroupStateDefault.groupName ||
                selectedGroupEditableState.uniqGroupName.length < 4 || selectedGroupEditableState.uniqGroupName === selectedGroupStateDefault.uniqGroupName ||
                !english.test(selectedGroupEditableState.uniqGroupName)
            ) {
                return alertCtx.showAlert(t('error'), t('All fields must be more then 4 chars, uniq name in english'), 'sm')
                // return alert(t('All fields must be more then 4 chars, uniq name in english'))
            }
            groupsReq.addNewGroup(selectedGroupEditableState.uniqGroupName, selectedGroupEditableState.groupName)
            setSelectedGroupState(selectedGroupStateDefault)
            setSelectedGroupEditableState(selectedGroupStateDefault)
            setOnCreateNewGroupMsgState(t('The group created successfully please select the group from the drop down for further treatment', { groupType: t(groupSetting.type) }))
        }
        else {
            return //do nothing
        }

        //todo auto select created group
    }, [alertCtx, selectedGroupStateDefault, selectedGroupEditableState, t, isSelectedDefaulGroup])

    const onGroupRemoveClick = useCallback(() => {
        if (isSelectedDefaulGroup) {
            return alertCtx.showAlert(t('error'), t('Please select group', { groupType: t(groupSetting.type) }), 'sm')
            // return alert(t('Please select group'))
        }
        groupsReq.removeGroup(selectedGroupState.uniqGroupName)
        setSelectedGroupState(selectedGroupStateDefault)
        setSelectedGroupEditableState(selectedGroupStateDefault)
    }, [selectedGroupState, alertCtx, selectedGroupStateDefault, setSelectedGroupEditableState, setSelectedGroupState, t, isSelectedDefaulGroup])

    const onClickRemoveAgentFromGroup = useCallback((agentName) => {
        if (isSelectedDefaulGroup) {
            return alertCtx.showAlert(t('error'), t('Please select group', { groupType: t(groupSetting.type) }), 'sm')
            // return alert(t('Please select group'))
        }
        groupsReq.group_remove_agent_byname(selectedGroupState.uniqGroupName, agentName)
        //todo - request remove agent from group
    }, [isSelectedDefaulGroup, alertCtx, selectedGroupState, t])

    const onClickSaveAgentToGroup = useCallback((agentName) => {
        if (isSelectedDefaulGroup) {
            return alertCtx.showAlert(t('error'), t('Please select group', { groupType: t(groupSetting.type) }), 'sm')
            // return alert(t('Please select group'))
        }
        groupsReq.group_add_agent_byname(selectedGroupState.uniqGroupName, agentName)
        //todo - request add agent to group
    }, [isSelectedDefaulGroup, alertCtx, selectedGroupState, t])

    let company_groupList_dropDownListItems = []
    if (company_groupList && company_groupList.length > 0) {
        company_groupList_dropDownListItems =
            company_groupList.map((group) => <Dropdown.Item key={group._id} onClick={() => onGroupSelect(group)} className={styles.specificSettingsDropDownItem}>{group.groupName}</Dropdown.Item>)
    }

    let selectedGroup_Agents = undefined
    if (!isSelectedDefaulGroup) {
        if (props.agentsList && props.agentsList.length > 0) {
            selectedGroup_Agents = props.agentsList.map(agent => {
                const isAgentInGroup = agent.groupList.find(agentGroup => agentGroup._id === selectedGroupState._id)
                const isAgentOnline = props.listOfOnlineAgents.find(OnlineAgent => OnlineAgent.agentName === agent.agentName)
                let agentAvatar = undefined
                if (isAgentOnline) {
                    // agentAvatar = <img  alt='Cant load img' src={serverUrl + '/users/avatar/' + agent.avatarName} onError={(event) => event.target.src = userIcon} className='user_img_online' />
                    agentAvatar = <img alt='Cant load img' src={userIcon} onError={(event) => event.target.src = userIcon} className='user_img_online' />
                }
                else {
                    // agentAvatar = <img loading="lazy" alt='Cant load img' src={serverUrl + '/users/avatar/' + agent.avatarName} onError={(event) => event.target.src = userIcon} className='user_img_offline' />
                    agentAvatar = <img alt='Cant load img' src={userIcon} onError={(event) => event.target.src = userIcon} className='user_img_offline' />
                }
                if (isAgentInGroup) {
                    return <div key={agent._id} onClick={() => onClickRemoveAgentFromGroup(agent.agentName)} className='agentsDropDownItem'> {[agentAvatar, agent.agentName, <i className={"fas fa-minus " + styles.centerGroupPlusMinusFont} />]} </div>
                }
                else {
                    return <div key={agent._id} onClick={() => onClickSaveAgentToGroup(agent.agentName)} className='agentsDropDownItem'> {[agentAvatar, agent.agentName, <i className={"fas fa-plus " + styles.centerGroupPlusMinusFont} />]} </div>
                }
            })
        }
    }
    const isGroupsSupportedOptions = [true, false]
    const groupLabelDropDownOptions = [{
        name: 'Subject',
        value: 'Subject'
    },
    {
        name: 'Group',
        value: 'Group'
    },
    {
        name: 'Department',
        value: 'Department'
    }
    ]

    return (
        <Fragment>
            <section className={styles.SettingsSection}>
                <h2 className={styles.settingsTitle}>{t('Group Settings', { groupType: t(groupSetting.type) })}</h2>
                <DropDownV2
                    nowSelected={groupLabelDropDownOptions.find(option => option.name === groupSetting.type)}
                    onSelect={(selectedItem) => setSettingsMiddleware('group', 'groupType', selectedItem.value)}
                    label={t('Select label for group')}
                    items={groupLabelDropDownOptions}
                />
                <SettingsDropDown nowSelected={groupSetting.isGroupsSupported} setSettings={setSettingsMiddleware} settingType={'group'} label={t('Support Groups', { groupType: t(groupSetting.type + 's') })} settingName={'isGroupsSupported'} items={isGroupsSupportedOptions} />
                <div className={styles.someSettingDiv}>
                    <span className={styles.specificSettingsText}>{t('Select group', { groupType: t(groupSetting.type) })} </span>
                    <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={selectedGroupState.groupName}>
                        {company_groupList_dropDownListItems}
                    </DropdownButton>
                </div>
            </section >

            <section className={styles.groupManagementPanelSection}>
                <h2 className={styles.settingsTitle}>{t('Group management', { groupType: t(groupSetting.type) })}</h2>
                <div className={styles.someSettingDiv}>
                    <span className={styles.specificSettingsText}>{t('Group name', { groupType: t(groupSetting.type) })} </span>
                    <input type='text' disabled={!isSelectedDefaulGroup} value={selectedGroupEditableState.groupName === selectedGroupStateDefault.groupName ? '' : selectedGroupEditableState.groupName} onChange={(e) => onGroupEditableInputChange({ groupName: e.target.value })} className={styles.groupName} />
                </div>
                <div className={styles.someSettingDiv}>
                    <span className={styles.specificSettingsText}>{t('Uniq system name')} </span>
                    <input type='text' disabled={!isSelectedDefaulGroup} value={selectedGroupEditableState.uniqGroupName === selectedGroupStateDefault.uniqGroupName ? '' : selectedGroupEditableState.uniqGroupName} onChange={(e) => onGroupEditableInputChange({ uniqGroupName: e.target.value })} className={styles.groupName} />
                </div>
                <div className={styles.saveRemoveGroupDiv}>
                    {isSelectedDefaulGroup ?
                        <Button className={styles.saveOrRemoveGroupBtn} variant='success' onClick={onGroupSaveClick} >{t('Save group', { groupType: t(groupSetting.type) })}</Button>
                        :
                        (
                            <Fragment>
                                <span style={{ "marginRight": "20px" }} className={styles.specificSettingsText}>{t('Add agents to the group', { groupType: t(groupSetting.type) })} </span>
                                <section className={styles.groupAgentsSection}>
                                    {selectedGroup_Agents}
                                </section>
                                <Button className={styles.saveOrRemoveGroupBtn} variant='danger' onClick={onGroupRemoveClick}>{t('Remove group', { groupType: t(groupSetting.type) })}</Button>
                            </Fragment>
                        )
                    }
                    <h6 className={styles.groupCreateMsg}>{onCreateNewGroupMsgState}</h6>
                </div>
            </section>
        </Fragment>
    )
}

export default CallBackSettings
